export enum Country {
    URUGUAY = "UY",
    ESPANA = "ES",
    PARAGUAY = "PY",
    GUATEMALA = "GT"
}